/*
 * @Description: 所有的原物料检测
 * @Author: wangwangwang
 * @Date: 2020-09-21 15:30:40
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-06-29 10:29:38
 */
import request from "@/utils/request";
/**
 * @Description: 原物料检测获取数据接口
 * @Param: "dataTypeId":1,  1。快速检测；2.批量检测；3.复检，4.抽检
 * @Author: wangwangwang
 */
export const queryPage = "/icps/system/sign/intelligent/make/querypage";
/**
 * @Description: 原物料检测其他检测的数据
 * @Param:
 * @Author: wangwangwang
 */
export const queryOtherPage =
  "/icps/system/sign/intelligent/make/queryOtherPage";
/**
 * @Description: 混凝土检测、出场检测
 * @Param:
 * @Author: wangwangwang
 */
export const concreteQueryPage =
  "/icps/system/sign/intelligent/concrete/queryPage";
/**
 * @Description: 混凝土检测、其他检测
 * @Param:
 * @Author: wangwangwang
 */
export const concreteQueryOtherPage =
  "/icps/system/sign/intelligent/concrete/queryOtherPage";
  //导出
export const Download =
  "/icps/system/sign/intelligent/concrete/export";
export const exportPage =
  "/icps/system/sign/intelligent/make/exportDetection";
export const exportPressureData =
  "/icps/system/sign/intelligent/concrete/exportPressureData";

// 获取检验标准
export function getStationNormByDetection(params) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/getStationNormByDetection",
    method: "post",
    data: params,
  });
}
// 判断检测结果为NG还是OK
export function countCheckResult(params) {
  return request({
    url: "/icps/system/sign/intelligent/result/countResult",
    method: "post",
    data: params,
  });
}
// 提交检测数据
export function saveCheckOutResult(params) {
  return request({
    url: "/icps/system/sign/intelligent/result/saveResult",
    method: "post",
    data: params,
  });
}

// 获取已提交的检测数据
export function getCheckResult(params) {
  return request({
    url: "/icps/system/sign/intelligent/result/getDetail",
    method: "post",
    data: params,
  });
}

// 获取其他检测的检测类别
export function getCheckoutType(params) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/getBinding",
    method: "post",
    data: params,
  });
}
// 保存选择的检测类别
export function createOther(params) {
  return request({
    url: '/icps/system/sign/intelligent/make/createOther',
    method: 'post',
    data: params
  })
}
// 获取检测历史
export function getListByPid(params) {
  return request({
    url: '/icps/system/sign/intelligent/make/getListByPid',
    method: 'post',
    data: params
  })
}

// 状态改为取样
export function makeupdStatus(params) {
  return request({
    url: '/icps/system/sign/intelligent/make/updStatus',
    method: 'post',
    data: params
  })
}

// 混凝土状态改为取样
export function makeupdStatus2(params) {
  return request({
    url: '/icps/system/sign/intelligent/concrete/updStatus',
    method: 'post',
    data: params
  })
}

// 混凝土状态改为取样
export function getOneByPidAndRawId(params) {
  return request({
    url: '/icps/system/sign/dataCollection/contractProduct/getOneByPidAndRawId',
    method: 'post',
    data: params
  })
}
/**
 * @Description: 新增回弹养护作业数据
 * @Param: 
 * @Author: wangwangwang
 */
export function SaveSpringBack(data) {
  return request({
    url: '/icps/system/sign/intelligent/springbackMaintenance/save',
    method: 'post',
    data
  })
}

/**
 * @Description: 获取供应计划列表
 * @Param: 
 * @Author: wangwangwang
 */
export function queryListBysupplierId(data) {
  return request({
    url: '/icps/system/sign/dataCollection/supplierPlanDetail/queryListBysupplierId',
    method: 'post',
    data
  })
}

/**
 * @Description: 修改计划提交
 * @Param: 
 * @Author: wangwangwang
 */
export function makeupdatePlan(data) {
  return request({
    url: '/icps/system/sign/intelligent/make/updatePlan',
    method: 'post',
    data
  })
}

/**
 * @Description: 标签打印
 * @Param: 
 * @Author: wangwangwang
 */
 export function getPrintData(data) {
  return request({
    url: '/icps/system/sign/intelligent/make/getPrintData',
    method: 'post',
    data
  })
}
//混凝土检测录入保存
 export function concreteSaveResult(data) {
  return request({
    url: '/icps/system/sign/intelligent/ConcreteQuality/saveResult',
    method: 'post',
    data
  })
}
//手动录入抗压数据
 export function savePressureData(data) {
  return request({
    url: '/icps/system/sign/intelligent/concrete/savePressureData',
    method: 'post',
    data
  })
}
//修改备注
 export function addOrUpdateRemark(data) {
  return request({
    url: '/icps/system/sign/intelligent/concrete/addOrUpdateRemark',
    method: 'post',
    data
  })
}
//修改记录
 export function queryResord(data) {
  return request({
    url: '/icps/system/sign/intelligent/detectionValue/queryResord',
    method: 'post',
    data
  })
}
//获取抗压强度数据
 export function queryPressureData(data) {
  return request({
    url: '/icps/system/sign/intelligent/concrete/queryPressureData',
    method: 'post',
    data
  })
}